/**
 * CircuitBreakerChecker - Utility for checking circuit breaker state
 * 
 * Extracted from TypesetterWorkerClient for better modularity and testability.
 * 
 * This utility provides functions for checking if a circuit breaker should trigger
 * based on consecutive failure counts, preventing infinite retry loops.
 */

/**
 * Parameters for circuit breaker check
 */
export interface CircuitBreakerParams {
  consecutiveFailures: number;
  maxConsecutiveFailures: number;
}

/**
 * Result of circuit breaker check
 */
export interface CircuitBreakerResult {
  shouldTrigger: boolean;
  errorMessage: string;
}

/**
 * Check if circuit breaker should trigger
 * 
 * Determines if the circuit breaker should trigger based on consecutive failure count.
 * 
 * @param params - Circuit breaker parameters
 * @returns Object indicating if circuit breaker should trigger and error message
 */
export function checkCircuitBreaker(params: CircuitBreakerParams): CircuitBreakerResult {
  const { consecutiveFailures, maxConsecutiveFailures } = params;
  
  if (consecutiveFailures >= maxConsecutiveFailures) {
    return {
      shouldTrigger: true,
      errorMessage: 'WASM engine crashed after multiple attempts - please reload the page'
    };
  }
  
  return {
    shouldTrigger: false,
    errorMessage: ''
  };
}

/**
 * Log circuit breaker trigger
 * 
 * @param consecutiveFailures - Number of consecutive failures
 */
export function logCircuitBreakerTrigger(consecutiveFailures: number): void {
  console.error(`🔥 [TypesetterWorkerClient] CIRCUIT BREAKER TRIGGERED: ${consecutiveFailures} consecutive WASM crashes`);
}


